import React from "react";
import styled from "styled-components";
import Box from "../../../components/Box";
import { Colors } from "../../../config";
import EachViewDetails from "./EachViewDetails";

const DetailsContainer = ({ flightName, imgSrc }) => {
  return (
    <ContainerWrapper>
      <Box boxBorder="0.375rem" boxColor={Colors.gallery} overflowHidden>
        <EachViewDetails flightName={flightName} imgSrc={imgSrc} />
        <EachViewDetails flightName={flightName} imgSrc={imgSrc} />
      </Box>
    </ContainerWrapper>
  );
};

export default DetailsContainer;

const ContainerWrapper = styled.div`
  transform: translateY(-1.5rem);
`;
